import Product from '@src/quince-site-common/src/domains/Product'
import { ProductOptionName } from '@src/quince-site-common/src/domains/ProductOption'

/** Matches `optionName` on add-on rows merged into `combinedProductOptions`. */
export const MINI_PDP_MERGED_ADDON_OPTION_NAME = 'Merged-Product-Option'

export interface MiniPdpSizeSectionRowMeta {
  key: ProductOptionName | number
  optionName?: string
  displaySequence: number
}

export function buildMiniPdpSizeSectionSummarySegments(
  product: Product,
  selectedSiblingProductId: number | undefined,
  optionNameSelectedValueMap: Record<string, string>,
  sizeAndMergedRows: MiniPdpSizeSectionRowMeta[],
): { label: string; value?: string }[] {
  const segments: { label: string; value?: string }[] = []

  for (const row of sizeAndMergedRows) {
    if (row.key === ProductOptionName.Size) {
      const po = product.productOptions.find(p => p.name === ProductOptionName.Size)
      const raw = optionNameSelectedValueMap[ProductOptionName.Size]
      if (po) {
        const display = po.values?.find(v => v.value === raw)?.displayName ?? raw
        segments.push({ label: po.displayName ?? String(po.name), value: display })
      }
    } else if (row.optionName === MINI_PDP_MERGED_ADDON_OPTION_NAME) {
      const group = product.addOnProductOptionGroups?.find(g => g.groupId === row.key)
      if (group) {
        const selectedItem = group.groupItems.find(i => i.spid === selectedSiblingProductId)
        const label = group.groupOptionDisplayName
        const mergedDisplayValue = selectedItem?.mergeOptionValueDisplayName
        if (label) {
          segments.push({
            label,
            value: mergedDisplayValue,
          })
        }
      }
    }
  }

  return segments
}
